// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3K1qR","inputDescription":"styles_inputDescription__2-Mvz"};